import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { getTestIds } from '../../utils/TestIds';
import { Typography } from '../Typography';
import styles from './BulletList.module.scss';
export const GetBulletListItemTID = (parentTestId)=>getTestIds(parentTestId);
const bulletSizeClassMap = {
    small: styles.bulletSmall,
    default: styles.bulletDefault,
    large: styles.bulletLarge
};
const firstLineVariantClassMap = {
    h1: styles.firstLineH1,
    h2: styles.firstLineH2,
    h3: styles.firstLineH3,
    h4: styles.firstLineH4,
    h5: styles.firstLineH5,
    h6: styles.firstLineH6,
    paragraph1: styles.firstLineParagraph1,
    paragraph2: styles.firstLineParagraph2,
    paragraph3: styles.firstLineParagraph3
};
export const BulletListItem = (param)=>{
    let { children, custom = false, variant = 'paragraph1', skin = 'standard', weight = 'light', bulletVariant = 'disc', bulletSize = 'default', bulletColor, bulletAlignment = 'center', className, testId } = param;
    const { BulletListItemTestIds } = useMemo(()=>GetBulletListItemTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs("li", {
        className: cn(styles.item, bulletAlignment === 'firstLine' && [
            styles.itemBulletOnFirstLine,
            firstLineVariantClassMap[variant]
        ], className),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.bullet, styles.bulletMargin, styles[bulletVariant], bulletVariant !== 'dash' && bulletSizeClassMap[bulletSize]),
                style: bulletColor ? {
                    color: bulletColor
                } : undefined,
                "data-testid": BulletListItemTestIds.Bullet()
            }),
            custom ? children : /*#__PURE__*/ _jsx(Typography, {
                variant: variant,
                skin: skin,
                weight: weight,
                testId: BulletListItemTestIds.Content(),
                children: children
            })
        ]
    });
};
